import { Button, Card, CardContent, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { Close, CompareArrows } from "@material-ui/icons";
import MaterialTable from "material-table";
import { useContext } from "react";
import { config as url } from "../../../common/config";
import FetchDataContext from "../../../context/fetchData/fetchDataContext";
import FormPicker from "./FormPicker";

const StyledTableCell = withStyles((theme) => ({
	head: {
		backgroundColor: "#3B6F87",
		color: theme.palette.common.white,
		border: "1px solid",
	},
	body: {
		fontSize: 14,
	},
}))(TableCell);

const StyledTableCell2 = withStyles((theme) => ({
	head: {
		backgroundColor: "#3B6F87",
		color: theme.palette.common.white,
		border: "1px solid",
	},
	body: {
		fontSize: 14,
	},
}))(TableCell);

const StyledTableCell3 = withStyles((theme) => ({
	head: {
		backgroundColor: "#3B6F87",
		color: theme.palette.common.white,
		border: "1px solid",
	},
	body: {
		fontSize: 14,
		fontWeight: "bold",
	},
}))(TableCell);

const TableCompare = (props) => {
	const BaseUrl = `${url.dashboard}`;
	const fetchData = useContext(FetchDataContext);
	const { refreshDataCompare, tableRefCompare } = fetchData;

	const refreshData = () => {
		return refreshDataCompare();
	};
	const { getDataTables, state, setState, HandleClickedTable, type } = props;

	const columns = [
		{ title: "Kategori", field: "kategori" },
		{ title: "Layanan", field: "layanan" },
		{ title: "Jumlah", field: "total" },
		{ title: "Detail", field: "detail" },
		{ title: "Action", field: "action" },
	];

	return (
		<Card
			style={{
				paddingBottom: 28,
				backgroundColor: "white",
				boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
				borderRadius: "10px",
			}}
		>
			<CardContent>
				<div style={{ display: "flex", justifyContent: "space-between" }}>
					<Typography component="h5" variant="h5">
						{type ?? "Total Tiket Per Kategori"}
					</Typography>
					{!type && (
						<Button
							variant="contained"
							style={{ backgroundColor: "orange" }}
							endIcon={<CompareArrows />}
							onClick={() => HandleClickedTable(true)}
						>
							Bandingkan Data
						</Button>
					)}

					{type && (
						<Button
							// style={{ backgroundColor: "#F47174" }}
							endIcon={<Close />}
							onClick={() => HandleClickedTable(false)}
						/>
					)}
				</div>

				<div
					style={{
						fontFamily: "sans-serif",
						textAlign: "center",
						marginTop: 20,
					}}
				>
					<FormPicker
						state={state}
						setState={setState}
						handleSearch={refreshData}
					/>
					<MaterialTable
						style={{ boxShadow: "none" }}
						title={false}
						columns={columns}
						tableRef={tableRefCompare}
						data={getDataTables({
							url: `${BaseUrl}/issue_table`,
							state: state,
							type: "listDashboard",
						})}
						components={{
							Header: (props) => {
								return (
									<TableHead>
										<TableRow>
											<StyledTableCell rowSpan={2} align="center">
												Kategori
											</StyledTableCell>
											<StyledTableCell rowSpan={2} align="center">
												Layanan
											</StyledTableCell>
											<StyledTableCell rowSpan={2} align="center">
												Jumlah
											</StyledTableCell>
											<StyledTableCell colSpan={4} align="center">
												Detail
											</StyledTableCell>
										</TableRow>
										<TableRow>
											<StyledTableCell2
												align="center"
												style={{
													color: "#CC0101",
												}}
											>
												Critical
											</StyledTableCell2>
											<StyledTableCell2
												align="center"
												style={{
													color: "#CC4400",
												}}
											>
												High
											</StyledTableCell2>
											<StyledTableCell2
												align="center"
												style={{
													color: "#FFBF01",
												}}
											>
												Medium
											</StyledTableCell2>
											<StyledTableCell2
												align="center"
												style={{
													color: "#7bd406",
												}}
											>
												Low
											</StyledTableCell2>
										</TableRow>
									</TableHead>
								);
							},
							Row: ({ data }) => {
								return (
									<TableRow>
										<TableCell align="center">{data.kategori}</TableCell>
										<TableCell align="center">{data.layanan}</TableCell>
										<StyledTableCell3 align="center">
											{data.total}
										</StyledTableCell3>
										<TableCell
											align="center"
											style={{
												color: "#CC0101",
												fontWeight: "bold",
												fontSize: 14,
											}}
										>
											{data.critical}
										</TableCell>
										<TableCell
											align="center"
											style={{
												color: "#CC4400",
												fontWeight: "bold",
												fontSize: 14,
											}}
										>
											{data.high}
										</TableCell>
										<TableCell
											align="center"
											style={{
												color: "#FFBF01",
												fontWeight: "bold",
												fontSize: 14,
											}}
										>
											{data.medium}
										</TableCell>
										<TableCell
											align="center"
											style={{
												color: "#7bd406",
												fontWeight: "bold",
												fontSize: 14,
											}}
										>
											{data.low}
										</TableCell>
									</TableRow>
								);
							},
						}}
						options={{
							search: false,
							paginationType: "stepped",
							pageSize: 10,
							pageSizeOptions: [10, 25, 50, 75, 100],
						}}
					/>
				</div>
			</CardContent>
		</Card>
	);
};

export default TableCompare;
